<template>
  <main id="store-gift-apply">
    <NavFooter />
    <Empty v-if="!salesman || !user" :loading="true" />
    <div v-else>
      <Login v-if="components.login" v-on:dismiss="components.login = false" :show-close="false" />
      <div class="top">
        <h1>优学卡店家入驻</h1>
        <p>「王冰暗示法英语」是 AnyTeach 约课平台旗下的招牌英语课程，独创暗示法教学法，提出 250 小时学完中学六年全部英语，以快速提分、不刷题海、整体教学为特点，由平台的上千名暗示法名师提供 1 对 3 线上小班教学。平台现推出优学卡合作方案，以促进顾客在合作店家消费，保持后续消费以及提升合作店家的顾客到访量。</p>
        <img src="https://anyteach.oss-cn-shanghai.aliyuncs.com/store-gift/store-process.jpg" />
      </div>
      <div class="form">
        <div class="form-section">
          <h1>基本信息</h1>
          <div class="form-item">
            <h2>申请人</h2>
            <input type="text" v-model.trim="form.manager_name" placeholder="您的真实姓名" />
          </div>
          <div class="form-item">
            <h2>推荐人</h2>
            <el-select v-model="form.salesman_id" clearable placeholder="选择业务员姓名/手机尾号">
              <el-option
                v-for="item in salesman"
                :key="item.id"
                :label="item.name + ' ' + item.phone.substring(item.phone.length - 4)"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-item">
            <h2>商家名称</h2>
            <input type="text" v-model="form.name" placeholder="如：全芳面包" />
          </div>
          <div class="form-item">
            <h2>密码</h2>
            <p>将为您开通店家账号，请设置您想要的密码</p>
            <input type="text" v-model.trim="form.password" placeholder="只能填写英文和数字，至少 4 个字符" />
          </div>
        </div>
        <div class="form-section">
          <h1>门店信息</h1>
          <transition-group name="store-list" class="store-list">
            <div class="store-item" v-for="(item, index) in form.store_info" :key="index + 1">
              <div v-if="form.store_info.length > 1" class="form-item">
                <h2>分店 {{ index + 1 }}</h2>
                <div class="text-link remove-store" @click="removeStore(index)">
                  <i class="anyteachicon anyteach-delete" />删除分店
                </div>
                <input type="text" v-model.trim="item.name" placeholder="如：丰泽区店" />
              </div>
              <div class="form-item">
                <h2>电话</h2>
                <input type="text" v-model.trim="item.mobile" placeholder="固定电话请包含区号" />
              </div>
              <div class="form-item">
                <h2>地址</h2>
                <input type="text" v-model.trim="item.addr" placeholder="请包含所在城市" />
              </div>
            </div>
          </transition-group>
          <span @click="addStore" class="add-store text-link" v-if="form.store_info.length < 100">
            <i class="anyteachicon anyteach-plus" />添加分店
          </span>
        </div>
        <div class="form-section">
          <h1>礼品</h1>
          <div class="form-item">
            <h2>名称</h2>
            <p>请勿提供现金券、代金券等非实物礼品</p>
            <input type="text" v-model.trim="form.gift[0].name" placeholder="如：金枪鱼三明治" />
          </div>
          <div class="form-item">
            <h2>价值</h2>
            <input type="number" v-model.trim.number="form.gift[0].price" placeholder="至少 66 元" />
          </div>
        </div>
      </div>
      <div @click="submit" class="submit">提交申请</div>
    </div>
  </main>
</template>

<script>
import Vue from "vue"
import NavFooter from "@/components/public/footer"
import Empty from "@/components/public/Empty"
import Login from "@/components/popup/Login"
import { Select, Option } from "element-ui"

Vue.use(Select)
Vue.use(Option)

export default {
  name: "StoreGiftApply",
  components: {
    NavFooter,
    Empty,
    Login,
    Select
  },
  data() {
    return {
      components: {
        login: false
      },
      state: {
        status: undefined
      },
      salesman: undefined,
      form: {
        name: "",
        password: "",
        manager_name: "",
        bank_person: "",
        bank_account: "",
        salesman_id: undefined,
        store_info: [
          {
            name: "",
            mobile: "",
            addr: "",
          }
        ],
        gift: [
          {
            name: "",
            price: 66,
            num: 1,
          }
        ]
      }
    }
  },
  created() {
    // this.getStoreInfo()
    this.getSalesman()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  watch: {
    user: {
      immediate: true,
      handler: function (val) {
        if (val && val.user_id && !val.mobile) {
          this.$toast("验证手机号后即可填写")
          this.components.login = true
        } else {
          this.components.login = false
        }
      }
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    async getSalesman() {
      this.salesman = await this.$api.storeGift.GET_SALESMAN()
    },
    async getStoreInfo() {
      const res = await this.$api.storeGift.STORE_INFO()
      if (!res.msg) {
        this.state.status = 0
      } else {
        this.state.status = res.msg.status
      }
      this.$wxShare({
        title: "优学卡店家入驻",
        desc: "想要不花一分钱提升顾客消费和到访量？点击申请免费合作 →",
        link: location.origin + "/store-gift/apply",
        imgUrl: window.logo2019
      })
    },
    async submit() {
      try {
        this.validate()
      } catch (err) {
        return this.$toastError(err)
      }
      this.$toastLoading("正在提交...")
      const { code, msg } = await this.$api.storeGift.ADD_STORE({
        name: this.form.name,
        password: this.form.password,
        manager_name: this.form.manager_name,
        manager_mobile: this.user.mobile,
        store_info: this.form.store_info,
        salesman_id: this.form.salesman_id,
        gift: this.form.gift,
        bank_person: " ",
        bank_account: " ",
        type: 4
      })
      if (code !== "1000") {
        return this.$toastError(msg)
      } else {
        this.$toastSuccess("提交成功")
        this.$router.push("/store-gift/apply?store_id=" + msg)
      }
    },
    validate() {
      let required = [this.form.name, this.form.password, this.form.manager_name, this.form.gift[0].name, this.form.gift[0].price, this.form.store_info[0].mobile, this.form.store_info[0].addr, this.form.salesman_id]
      if (!required.every(item => Boolean(item))) throw "请填写所有问题"
      if (this.form.store_info.length > 1) {
        this.form.store_info.forEach(item => {
          if (!Object.values(item).every(item => Boolean(item))) throw "请填写所有问题"
        })
      }
    },
    addStore() {
      this.form.store_info.push({
        name: "",
        mobile: "",
        addr: "",
      })
    },
    removeStore(index) {
      this.form.store_info.splice(index, 1)
      if (this.form.store_info.length === 1) {
        this.form.store_info[0].name = ""
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
p {
  margin: 0;
}
.top {
  border-top: 15px solid $primary;
  border-bottom: $border;
  padding: 10px 5% 0 5%;
  img {
    width: 100%;
    margin: 10px 0;
  }
  h1 {
    font-size: 1.25rem;
  }
  p {
    font-size: 0.85rem;
    margin-block-end: 10px;
  }
}

.form {
  background: #eee;
  .form-section {
    width: 100%;
    background: white;
    padding: 10px 5% 0 5%;
    margin: 0 0 5px 0;
    height: auto;
    transition: height 0.5s;
    &:last-of-type {
      margin: 0;
    }
  }
  h1 {
    margin: 0px 0 10px 0;
    font-size: 1.25rem;
    color: $primary;
    &:first-child {
      margin-top: 0;
    }
  }
  .text-link {
    color: $primary;
    font-size: 0.85rem;
    transition: all 0.1s;
    line-height: 1;
    i {
      margin-right: 3px;
    }
    &:active {
      opacity: 0.6;
    }
  }
  .suggestion {
    margin: 5px 0 0 0;
  }
  .add-store {
    display: block;
    text-align: center;
    padding: 0 0 8px 0;
  }
  .remove-store {
    position: absolute;
    top: 0;
    right: 0;
    color: $red;
  }
  .form-item {
    padding: 0 0 20px 0;
    position: relative;
    &:last-of-type {
      padding: 0 0 10px 0;
    }
    h2 {
      font-size: 0.9rem;
      margin: 0;
    }
    p {
      font-size: 0.8rem;
      opacity: 0.6;
    }

    input::placeholder,
    ::v-deep input::placeholder {
      color: #6d6d6d;
    }

    .el-select {
      width: 100%;
    }

    input,
    input[type="text"],
    ::v-deep input {
      border: 1px solid #eee;
      border-radius: 4px;
      margin: 5px 0 0 0;
      width: 100%;
      font-size: 0.9rem;
      padding: 8px 7px;
      color: $black;
    }
  }
  .store-item {
    margin-top: 20px;
    transition: all 0.5s;
    height: auto;
    &:first-of-type {
      margin: 0;
    }
  }
  .store-list-enter,
  .store-list-leave-to {
    opacity: 0;
    height: 0;
    margin: 0;
    transform: scale(0.8);
  }
}

.submit {
  background: $primary;
  width: 90%;
  margin: 0 auto;
  padding: 10px 0;
  text-align: center;
  color: white;
  font-weight: bold;
  font-size: 0.9rem;
  border-radius: 4px;
}
</style>